<script lang="ts">
    import type {PageData} from './$types';
    import {getProject} from "$lib/calls/project";
    import ProjectStatus from "$lib/components/ProjectStatus.svelte";
    import {onMount} from "svelte";
    import ProjectWorkentries from "$lib/partials/ProjectWorkentries.svelte";
    import ProjectAssociates from "$lib/partials/ProjectAssociates.svelte";
    import {getUnit} from "$lib/calls/unit";
    import {currentUnit} from "$lib/stores/unit";
    import {availableAssociates, currentCustomer} from "$lib/stores/customer";
    import {customerAssociates} from "$lib/calls/customer";
    import {Spinner, TabItem, Tabs} from "flowbite-svelte";
    import PageLayout from "$lib/components/PageLayout.svelte";
    import {currentRoute} from "$lib/stores/route";
    import ProjectOverview from "$lib/components/ProjectOverview.svelte";
    import {ClipboardListSolid, PaperClipOutline, UsersGroupOutline, UsersSolid} from "flowbite-svelte-icons";
    import Timeline from "$lib/components/Timeline.svelte";
    import ProjectDocuments from "$lib/components/ProjectDocuments.svelte";

    export let data: PageData;

    let loading = true;
    let project;
    onMount(async () => {

        project = await getProject(data.uuid)
        $currentRoute = {label: project.name}
        currentCustomer.set(project.customer)

        const associates = await customerAssociates(project.customer.uuid);
        availableAssociates.set(associates);

        getUnit(project.customer).then(unit => {
            currentUnit.set(unit)
        })
        loading = false;

    });

</script>
<svelte:head>
    <title>{project?.name}</title>
</svelte:head>
<PageLayout>
    {#if loading}
        <div class="text-center my-5">
            <Spinner/>
        </div>
    {:else}
        <div class="flex justify-between items-start w-full">
            <div class="flex-grow overflow-y-auto pr-8">
                <Tabs style="underline" contentClass="mt-5">
                    <TabItem open>
                        <div slot="title" class="flex items-center gap-2">
                            <ClipboardListSolid size="sm" />
                            Timeline
                        </div>
                        <div class="pl-5">
                            <Timeline bind:project />
                        </div>
                    </TabItem>
                    <TabItem>
                        <div slot="title" class="flex items-center gap-2">
                            <PaperClipOutline size="sm" />
                            Dokumente
                        </div>
                        <ProjectDocuments uploadable {project} />
                    </TabItem>
                    <TabItem>
                        <div slot="title" class="flex items-center gap-2">
                            <UsersSolid size="sm" />
                            Ansprechpartner
                        </div>
                        <ProjectAssociates bind:project />
                    </TabItem>
                    <TabItem>
                        <div slot="title" class="flex items-center gap-2">
                            <UsersGroupOutline size="sm" />
                            Team vor Ort
                        </div>
                        <ProjectWorkentries bind:project />
                    </TabItem>
                </Tabs>
            </div>

            <div class="mt-4">
                <div class="h-[54px]">
                    <ProjectStatus value={project.status} size="lg"/>
                </div>
                <ProjectOverview bind:project/>
            </div>
        </div>
    {/if}
</PageLayout>